// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-gold[data-v-093beb6a]{color:#d1a60b}.bg-gold[data-v-093beb6a]{background:#d1a60b;color:#000}.left-arrow-tab[data-v-093beb6a]{clip-path:polygon(20% 0,100% 0,100% 100%,20% 100%,0 50%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
